import { api } from "@/api";

export const deleteLeagueNew = async (id: number): Promise<void> => {
  await api.client.delete(`/leagues-new/${id}`);
};
